export default __webpack_public_path__ + "static/media/Health-Safety-Policy_2.57d57a8e.jpg";